import { io, http, mq, config, history } from 'core';

import { Api, Predicates } from 'prismic.io';

import addCard from 'a/cards/add';

const asText = function() { return this && this.asText && this.asText() };
const asHtml = function() { return this && this.asHtml && this.asHtml() };

Api('https://accedecms.prismic.io/api', (err, Api) => {

    /* Fetching cards */
    Api.query(Predicates.at("document.type", "card"), {
        pageSize: 50
    }).then( data => {

        (data.results_size > 0)
        && data.results.forEach(res => {

            let card = {};

            card.id = parseInt(res.fragments[`card.index`].asText());

            ['description', 'fullDescription',
             'descriptionEn', 'fullDescriptionEn'].forEach(field =>
                 (card[field] = res.fragments[`card.${field}`]::asHtml()));

            ['title', 'titleEn',
             'section', 'media', 'icon', 'link'].forEach(field =>
                 (card[field] = res.fragments[`card.${field}`]::asText()));

            [{ group: 'images', single: 'Image', en: 'image_en' },
             { group: 'videos', single: 'Video' }].forEach(({ group, single, en }) => {

                 (res.fragments[`card.${group}`])
                 && (res.fragments[`card.${group}`]).value.forEach(doc => {

                     // if (card.title == 'Serviços') { debugger };

                     const media = doc.getText(single);
                     const mediaEn = en && doc.getText(en);

                     const item = {
                         media,
                         mediaPt: media,
                         mediaEn: mediaEn, // || media,
                         description: doc.getText('Description')
                     };

                     (Array.isArray(card[group]))
                                ? card[group].push(item)
                                : card[group] = [item]
                 });
             });

            addCard(card);

        })
    });
});



// WEBPACK FOOTER //
// ./app/fetch/index.js